export type AgentType =
  | "site-sourcing-chat"
  | "grey-belt-chat"
  | "general-chat"
  | "planning-applications-chat"
  | "planning-area-overview-chat"
  | "local-plan-chat";

export const agentTypeFriendlyNames: Record<AgentType, string> = {
  "site-sourcing-chat": "Site Sourcing",
  "grey-belt-chat": "Grey Belt knowledge",
  "general-chat": "General questions",
  "planning-applications-chat": "Planning Applications",
  "planning-area-overview-chat": "Planning Area Overview",
  "local-plan-chat": "Local Plan knowledge",
};
